
import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { ProductChoice } from '../../model/ngrx/Product-Choice.model';

export const ADD_PRODUCT_CHOICE = '[PRODUCTCHOICE] Add';
export const REMOVE_PRODUCT_CHOICE = '[PRODUCTCHOICE] Remove';

// AddPersonalDetails
export class AddProductChoice implements Action {
    readonly type = ADD_PRODUCT_CHOICE;

    constructor(public payload: ProductChoice) { }
}
// RemovePersonalDetails
export class RemoveProductChoice implements Action {
    readonly type = REMOVE_PRODUCT_CHOICE;

    constructor(public payload: number  ) { }
}

export type Actions = AddProductChoice | RemoveProductChoice;
